import React, { useEffect, useState } from 'react';
import Image from 'next/legacy/image';

import searchIcon from '../../public/images/search.svg';
import PopoverSearchPage from '../UnitsFilters/components/PopoverSearchPage';
import TopicsPopup from '../../components/Blog/TopicsPopup';
import { useRouter } from 'next/router';
import {
  validateEmail,
  getLeadIdFromLocalStorage,
  saveLeadIdToLocalStorage,
  getbrowserUUIDFromLocalStorage,
} from 'src/utils/utils';
import { SUBSCRIBE_FOR_BLOG_ALERTS } from 'apolloClient/mutations/alerts';
import { useMutation } from '@apollo/client';
import classnames from 'classnames';

type SearchBlogPageProps = {
  showSignUp?: boolean;
};

const SearchBlogPage: React.FC<SearchBlogPageProps> = ({ showSignUp }) => {
  const { push, query } = useRouter();
  const [searchValue, setSearchValue] = useState(query.search);
  const [emailValue, setEmailValue] = useState('');
  const [subscribeForBlogAlerts] = useMutation(SUBSCRIBE_FOR_BLOG_ALERTS);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    setSearchValue(query.search);
  }, [query.search]);

  useEffect(() => {
    if (isSubmitted) {
      const timeoutId = setTimeout(() => {
        setIsSubmitted(false);
      }, 5000);
      setEmailValue('');

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [isSubmitted]);

  const handleSearch = () => {
    push({ search: `search=${searchValue}`, pathname: '/blog' });
  };

  const signUp = async () => {
    if (emailValue && validateEmail(emailValue)) {
      const leadId = getLeadIdFromLocalStorage() || null;
      const browserUUID = getbrowserUUIDFromLocalStorage() || null;

      const data = await subscribeForBlogAlerts({
        variables: {
          email: emailValue,
          leadId,
          browserUUID,
        },
      });

      try {
        const newLeadId = data?.data?.subscribeUserForBlog?.newLeadId;

        if ((!leadId && newLeadId) || leadId !== newLeadId) {
          saveLeadIdToLocalStorage(newLeadId);
        }
      } catch (error) {
        console.error(error);
      }

      setIsSubmitted(true);
    }
  };

  return (
    <section className="sticky z-100 bg-white border-b top-[62px] md:top-16 lg:top-12 text-m pt-1.5 md:pt-[12px] lg:pt-[10px] lg:pb-0 border-beige-dark">
      <div className="container pr-[21px] pl-[24px] md:pl-[52px] md:ml-[0px] flex flex-col justify-between md:flex-row lg:pl-[21px] lg:max-w-[1180px] lg:mx-auto">
        <div className="container top-0 flex justify-between px-0 pl-0 md:justify-start lg:pr-12">
          <div className="relative flex h-[30px] px-[10px] py-[2px] md:!py-[5px] ml-[-2px] w-[203px] text-14-26-0.3 xl:text-16-26-0.3 mt-[3px] md:my-0 md:pb-1.5 border md:w-[246px] lg:h-[30px] border-beige-dark xl:py-[4px]">
            <input
              className="w-[85%] text-14-17-0.3 no-focus"
              type="text"
              placeholder="Search the blog"
              value={searchValue}
              onInput={(e) =>
                setSearchValue((e.target as HTMLInputElement).value)
              }
              onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
            />
            <div className="absolute right-3.5 top-[4px] text-16-26-0.3 text-beige-dark ">
              <Image src={searchIcon} alt="search" onClick={handleSearch} />
            </div>
          </div>
          <div className="mt-[-2px] md:mt-[-4px] md:pl-[22px] lg:pl-[4px] md:pt-0">
            <PopoverSearchPage
              name="TOPICS"
              render={({ close }: any) => <TopicsPopup />}
              buttonClassName="md:!pt-[10px]"
              arrowClasses="!flex !w-[15px] !h-[15px]"
            />
          </div>
        </div>
        <div
          className={classnames(
            `container hidden md:flex justify-between items-center h-10.5 lg:justify-end ml-[-2px] md:ml-0 px-0 lg:pl-12 pb-[12px] lg:pb-[13px] pr-0`,
            {
              'h-0 pb-[0px]': !showSignUp,
            }
          )}
        >
          {showSignUp && (
            <>
              {isSubmitted ? (
                <p>You have successfully signed for news and updates.</p>
              ) : (
                <>
                  <div className="flex relative h-10.5 md:h-[30px] w-[205px] text-14-26-0.3 lg:text-14-18-0.3 px-4 pl-[10px] my-1.5 md:my-0 py-[6.5px] md:pt-[6px] lg:pt-[6px] md:pb-1.5 border md:w-4/5 lg:w-[246px] border-beige-dark pr-10">
                    <input
                      className="w-full text-14-26-0.3 lg:text-14-17-0.3 no-focus"
                      type="text"
                      placeholder="Your email"
                      value={emailValue}
                      onChange={(e) =>
                        setEmailValue((e.target as HTMLInputElement).value)
                      }
                      onKeyDown={(e) => e.key === 'Enter' && signUp()}
                    />
                  </div>
                  <button
                    className="w-32 lg:w-[120px] h-10.5 md:h-[30px] text-14-26-0.3 uppercase md:text-16-26-0.3 bg-gold border-gold"
                    onClick={signUp}
                  >
                    Subscribe
                  </button>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default SearchBlogPage;
